import curry from "ramda/es/curry";
/**
 * Call action if cond meet the requirement
 *
 * @documented
 * @category Function
 *
 * @param {Boolean} cond resolved condition
 * @param {Function} action function to call
 * @return {*} result of the action
 *
 * @example
 *
 * doWhen(true, () => console.log('dog')) // => dog
 *
 */ const doWhen = curry((cond, action)=>cond ? action() : undefined);
export default doWhen;
